module.exports = __webpack_public_path__ + "img/account-grey24.6cc4e7af.svg";